import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-download"} maskId="square-filled-radius-0-stroke-1-IconFolderDownload"><path fillRule="evenodd" clipRule="evenodd" d="M2 3H10.2676L12.2676 6H22V20H2V3ZM12 17.7071L8.79289 14.5L9.5 13.7929L11.5 15.7929V10H12.5V15.7929L14.5 13.7929L15.2071 14.5L12 17.7071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderDownload;
